import moment from 'moment-timezone';
import { CUSTOM_DATE } from './constants';

export const typeOptions = [
  { value: 'todas', title: 'Todas' },
  { value: 'funeral', title: 'Exequial' },
  { value: 'life', title: 'Practiseguro' }
];

export const statusOptions = [
  { value: 'todas', title: 'Todas' },
  { value: 'active', title: 'Activas' },
  { value: 'cancelled', title: 'Canceladas' }
];

export const originalDateOptions = [
  { value: 'todas', title: 'Todas' },
  { value: moment().format('YYYY-MM-DD'), title: 'Hoy' },
  {
    value: `${moment()
      .startOf('week')
      .format('YYYY-MM-DD')} - ${moment()
      .endOf('week')
      .format('YYYY-MM-DD')}`,
    title: 'Esta semana'
  },
  {
    value: `${moment()
      .startOf('month')
      .format('YYYY-MM-DD')} - ${moment()
      .endOf('month')
      .format('YYYY-MM-DD')}`,
    title: 'Este mes'
  }
];

export const dateOptions = (customDate, registered_at) => [
  ...originalDateOptions,
  {
    value: customDate !== CUSTOM_DATE ? registered_at : CUSTOM_DATE,
    title: customDate !== CUSTOM_DATE ? registered_at : 'Personalizada'
  }
];
